import React from "react";
import { Link } from "react-router-dom";
import { API } from "@/lib/api";

// Content-driven logo: `size` is the admin-configured HEIGHT in px (aspect ratio preserved).
// The parent header uses items-center + vertical padding, so its height adapts to the logo.
// Responsive safety caps (maxWidth 72vw, maxHeight 30vh) prevent overflow on small screens.
export default function Logo({ className = "", dark = false, to = "/", mediaId, size }) {
  const h = size && size > 0 ? size : 44;
  const style = { height: `${h}px`, width: "auto", maxWidth: "72vw", maxHeight: "30vh" };
  const src = mediaId ? `${API}/media/file/${mediaId}` : "/delya-logo.png";
  if (dark) {
    return (
      <Link to={to} className={`inline-flex items-center bg-white rounded-lg px-2 py-1 shadow-sm ${className}`} data-testid="logo-link">
        <img src={src} alt="Delya" className="object-contain" style={style} />
      </Link>
    );
  }
  return (
    <Link to={to} className={`inline-flex items-center ${className}`} data-testid="logo-link">
      <img src={src} alt="Delya — Secrétariat médical" className="object-contain" style={style} />
    </Link>
  );
}
